export default __webpack_public_path__ + "static/media/Step.c2439e20.mp3";